import React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/dist/types';
import { SearchConfigure, SearchResultsHeadless } from '@uncinc/react-searchkit';
import { useTranslation } from 'react-i18next';
import { StatusMessage } from '@hvcgroep/design-system';
import { ParagraphVacancyTeasers } from '../../../../types/paragraphs';
import { Button, WysiwygField } from '../../../../components';
import SearchVacancies from '../../../../components/SearchVacancies';
import type { SearchVacanciesHit } from '../../../../components/SearchVacancies/types';
import SearchVacanciesResultsHit from '../../../../components/SearchVacancies/Results/Hit';

interface ParagraphVacancyTeasersProps {
  entity: ImmutableEntity<ParagraphVacancyTeasers>
}

const VacancyTeasers: React.FC<ParagraphVacancyTeasersProps> = ({
  entity,
}) => {
  const vacancyTeasers = entity.toJS();

  const query = vacancyTeasers.field_vacancy_query[0]?.value ?? '';

  const { t } = useTranslation();

  const {
    field_title: fieldTitle,
    field_text: fieldText,
    field_link: fieldLink,
  } = vacancyTeasers;

  return (
    <>
      {fieldTitle?.[0]?.value && (
        <div className="row">
          <div className="col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8">
            <h2 className="u-text-center">{fieldTitle[0].value}</h2>
          </div>
        </div>
      )}
      {fieldText?.[0]?.value && (
        <div className="row">
          <WysiwygField
            property="schema:text"
            className="ParagraphBlockReference__text col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8"
            html={fieldText[0].value}
          />
        </div>
      )}
      <SearchVacancies>
        <SearchConfigure
          hitsPerPage={2}
          // eslint-disable-next-line
          filters={query}
        />
        <SearchResultsHeadless
          className="u-margin--top--8"
        >
          {(hits: SearchVacanciesHit[]) => {
            if (!hits.length) {
              return (
                // @ts-expect-error
                <StatusMessage type="info">
                  {t('searchkit.vacancies.no_results')}
                </StatusMessage>
              );
            }

            return (
              <div className="row">
                {hits.map((hit) => {
                  return (
                    <div key={`vacancy-teaser-hit-${hit.nid[0]}`} className="VacanciesFrontpage__row col-12 col-md-6">
                      <SearchVacanciesResultsHit withBackground hit={hit} />
                    </div>
                  );
                })}
              </div>
            );
          }}
        </SearchResultsHeadless>
      </SearchVacancies>
      {fieldLink?.length > 0 && (
        <div className="row">
          <div className="u-multiple-buttons u-multiple-buttons--horizontal u-margin--top--8 u-text-center u-full-width">
            {fieldLink.map((field) => {
              return (
                <Button
                  type="secondary"
                  key={`link:${field.title}`}
                  href={field.alias || field.uri}
                >
                  {field.title}
                </Button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default VacancyTeasers;
